import { render } from "./MovementCreateComponent.vue?vue&type=template&id=d0511912&scoped=true&ts=true"
import script from "./MovementCreateComponent.vue?vue&type=script&lang=ts"
export * from "./MovementCreateComponent.vue?vue&type=script&lang=ts"

import "./MovementCreateComponent.vue?vue&type=style&index=0&id=d0511912&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0511912"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSelect,QInput,QIcon,QBtn,QDialog,QMenu,QTabs,QTab,QTabPanels,QTabPanel,QTooltip,QSeparator});
